// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerFile_root__HnJ_o"};